import React, { useEffect, useState } from "react";
import { Accordion, Form, Button } from "react-bootstrap";
import { IoIosAdd, IoMdClose } from "react-icons/io";
import Key from "../../../util/Key";

const SendTo = ({ fields, setFields, mails, setMails, edit, form }) => {
    const [sendTo, setSendTo] = useState("");

    const adMail = () => {
        setMails([...mails, { sendTo }]);
        setSendTo("");
    };

    const deteleMail = (item) => {
        const newDataMails = mails.filter((element) => element.sendTo !== item);
        setMails(newDataMails);
    };

    return (
        <>
            <Form.Label>Send to</Form.Label>
            {mails.map((item) => {
                return (
                    <div
                        className="content d-flex align-items-center"
                        key={Key()}
                    >
                        <p className="data">{item.sendTo}</p>
                        <p
                            className="delete btn"
                            onClick={() => {
                                deteleMail(item.sendTo);
                            }}
                        >
                            <IoMdClose />
                        </p>
                    </div>
                );
            })}
            <Form.Group
                className="mb-3 d-flex justify-content-between"
                controlId="exampleForm.ControlTextarea1"
            >
                <Form.Control
                    className="me-2"
                    size="sm"
                    type="mail"
                    value={sendTo}
                    name="send_to"
                    onChange={(e) => {
                        setSendTo(e.target.value);
                    }}
                />
                <Button
                    onClick={() => {
                        adMail();
                    }}
                >
                    <IoIosAdd />
                </Button>
            </Form.Group>
        </>
    );
};

export default SendTo;
